import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_organizations } from '@/graphql/queries'

export default {
  data() {
    return {
      organizationsList: [],

    }
  },
  methods: {
    async fetchOrganizations() {


      try {
        const response = await client.graphql({
          query: list_organizations
        })

        let responseData = JSON.parse(response.data.list_organizations)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.organizationsList = responseData.data
        } else {
          this.organizationsList = []
        }
        // console.log(this.organizationsList)

      } catch (error) {
        console.error("Error fetching organizations:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.organizationsList = [];
        throw error;
      }
    },
  },
};

